<template>
  <button v-bind="$props" class="Btn">
    <span class="Btn__text">
      <slot />
    </span>
    <Icon v-if="icon" :name="icon" />
  </button>
</template>

<script>
  import Icon from '@components/Icon'
  export default {
    components : { Icon },
    props: [ 'icon' ]
  }
</script>

<style lang="scss">
@import "~@sass/components/_Btn.scss";
</style>
